<template>
    <div id="Outing" class="starter-template">
        <div id="startId" style="position:absolute;top:0px;"></div>
        <a href="#" class="toTop" v-scroll-to="'#startId'" v-if="showHand">
            <font-awesome-icon icon="hand-point-up" size="2x" class="mb-5"/>
        </a>

        <div class="text-center">
            <b-spinner variant="primary" class="align-middle" v-if="loading" style="position:absolute;top:50%;z-index:1001"></b-spinner>
        </div>

        <b-container>
            <div class="descOuter">
            <div class="greyBack">
            <div v-show="showPlayer">
                <center><audio ref="audio" controls controlsList="nodownload">
                    Аудио не поддерживается</audio>
                </center>
            </div>
                <h1 class="text-center m-2 itsBkg">{{outing.title}}</h1>
<!--            <h1 v-if="outing.duratD=='0' || outing.duratD=='1'" class="text-center m-2 itsBkg">{{$t('OUTING',resLoc)}}: {{outing.outingName}}</h1>
            <h1 v-else class="text-center m-2 itsBkg">{{$t('OUTING_T',resLoc)}}: {{outing.outingName}}</h1> -->
            <b-row v-if="outing.toBar" class="mt-2">
                <b-col cols="2" class="ml-2 mr-2">
                    <span class="itnm">{{$t('WHERE_TO', resLoc)}}:</span>
                </b-col>
                <b-col class="ml-2 mr-2">
                    <span v-html="outing.toBar"></span>
                </b-col>
            </b-row>
            <b-row v-if="outing.startCountry" class="mt-2">
                <b-col cols="2" class="ml-2 mr-2">
                    <span class="itnm">{{$t('WHERE_FROM', resLoc)}}:</span>
                </b-col >
                <b-col class="ml-2 mr-2">
                    <span v-html="outing.fromBar"></span>
                </b-col>
            </b-row>

            <b-row class="mt-2">
                <b-col v-if="outingWayType || outingSubjType || individ || unaided" class="ml-2 mt-2">
                    <span class="itnm">{{$t('TYPE', resLoc)}}:&nbsp;</span>
                        <span v-if="individ || unaided">{{individ}} {{unaided}}<br></span>
                        <span v-if="outingWayType">{{outingWayType}}<br></span>
                        <span v-if="outingSubjType">{{outingSubjType}}</span>
                </b-col>
                <b-col  v-if="outing.duratD || outing.duratH || outing.duratM" class="ml-2 mt-2">
                    <b-row>
                        <b-col>
                            <span class="itnm">{{$t('DUR', resLoc)}}:</span>&nbsp;
                        </b-col>
                        <b-col>
                            <span v-if="outing.duratD!=0" style="white-space:nowrap">{{$t('DAYS',resLoc)}} {{outing.duratD }}<br></span>
                            <span v-if="outing.duratH!=0" style="white-space:nowrap">{{$t('HOURS',resLoc)}} {{outing.duratH }}<br></span>
                            <span v-if="outing.duratM!=0" style="white-space:nowrap">{{$t('MINUTES',resLoc)}} {{ outing.duratM }}</span>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col v-if="outing.price || outing.maxPrice" class="ml-2 mt-2">
                    <span v-if="outing.price && outing.maxPrice">
                        <span class="itnm">{{$t('PRICE', resLoc)}}:</span>
                        {{$t('FROM', resLoc)}}&nbsp;{{ outing.price}}
                        {{$t('TO', resLoc)}} {{ outing.maxPrice}}
                    </span>
                    <span v-else>
                        <span v-if="outing.forAll">
                            <span class="itnm">{{$t('PRICE', resLoc)}}:&nbsp;</span>
                            <span v-if="outing.price">{{ outing.price}}</span>
                            <span v-else>{{ outing.maxPrice}}</span>
                        </span>
                        <span v-else>
                            <span class="itnm">{{$t('PRICE_F', resLoc)}}:&nbsp;</span>
                            <span v-if="outing.price">{{ outing.price}}</span>
                            <span v-else>{{ outing.maxPrice}}</span>
                        </span>
                    </span>
                    <span v-html="outing.currency"></span>
                    <span v-if="outing.forAll"> {{$t('PRICE_A',resLoc)}}</span>
                    <span v-else> {{$t('PRICE_I',resLoc)}}</span>
                </b-col>

                <b-col v-if="outing.minSize || outing.maxSize" class="ml-2 mt-2">
                    <b-row>
                        <b-col>
                            <span class="itnm">{{$t('GR_SIZE', resLoc)}}:&nbsp;</span>
                        </b-col>
                        <b-col>
                            <span v-if="outing.minSize" style="white-space:nowrap">{{$t('FROM', resLoc)}}&nbsp;{{ outing.minSize }}<br></span>
                            <span v-if="outing.maxSize" style="white-space:nowrap">{{$t('TO', resLoc)}}&nbsp;{{ outing.maxSize }}</span>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col v-if="outing.minAge" class="ml-2 mt-2">
                    <span class="itnm">{{$t('AGE', resLoc)}}&nbsp;{{ outing.minAge }}+</span>
                </b-col>

            </b-row>
            <b-row class="mt-2">
                <b-col v-if="outing.schedule" class="ml-2 mt-2">
                    <span class="itnm">{{$t('SCHEDULE', resLoc)}}:</span> {{outing.schedule}}
                </b-col>
                <b-col v-if="outing.contacts" class="ml-2 mt-2">
                    <span class="itnm">{{$t('CONTACTS', resLoc)}}:</span> {{ outing.contacts }}
                </b-col>
                <b-col v-else class="ml-2 mt-2">
                    <span class="itnm">{{$t('ORG',resLoc)}}:</span>
                    <b-link :href="outing.companyUrl" rel="nofollow" target="_blank">
                        {{ outing.companyName }}
                    </b-link>
                </b-col>
            </b-row>
            <br>
            </div>
            <div v-html="desc" class="m-2" style="background-color:white"></div>
            <br>
            <div class="greyBack">
                <div style="color:#0b6478" class="m-2" v-if="outing.extUrl">
                    {{$t('PREL',resLoc)}}
                    <b-link :href="outing.extUrl" rel="nofollow" target="_blank">
                        {{$t('WEB_S',resLoc)}}.
                    </b-link>
                </div>
            </div>
            <div style="color:#0b6478;" class="m-2">{{$t('INACC',resLoc)}}
                <b-link href="mailto:libentour@gmail.com" rel="nofollow" target="_blank">
                    libentour@gmail.com
                </b-link>


            </div>
            <br>
            <div class="m-2 mb-5" v-if="showCmnts">
                <h5>{{$t('CMNTS',resLoc)}}</h5>
                <br>
                <div v-for="item in cmnts" :key="item.cmntName" class="m-2">
                    {{ $fmtDateTime(item.cmntName) }} {{ item.userName }}
                    <br><br>
                    <div v-html="item.desc"></div>
                </div>
            </div>
            <div class="mb8" v-if="$mq === 'md' || $mq === 'sm' || $mq === 'xs'"></div>
            <div v-else class="mb-5"></div>

        </div>
        </b-container>
        <b-container fluid class="footer text-center">
            <a v-b-popover.hover.top="this.$t('COMMENT', intLoc)" title="" v-if="outing.published && !outing.cmntedItemId">
                <b-button one-line class="m-1" v-on:click="comment()">
                    <font-awesome-icon icon="comment" size="lg"/>
                </b-button>
            </a>
            <b-button one-line class="m-1" v-on:click="showOutingDetails()" v-if="outing.hasTrip || outing.hasPlace">{{ outingName }}</b-button>
            <b-button v-else one-line class="m-1" disabled>{{ outingName }}</b-button>
            <a v-b-popover.hover.top="this.$t('ADD_C', intLoc)" title="" v-if="!compareBox.outingName">
                <b-button one-line class="m-1" v-on:click="addToCompare()">
                    <font-awesome-icon icon="plus" size="lg"/>
                </b-button>
            </a>
            <a v-b-popover.hover.top="this.$t('COMPARE', intLoc)" title=""
                    v-if="compareBox.userName && compareBox.outingName && (userName != compareBox.userName || outingName != compareBox.outingName)">
                <b-button one-line class="m-1" v-on:click="compare()">
                    <font-awesome-icon icon="balance-scale" size="lg"/>
                </b-button>
            </a>
            <a v-b-popover.hover.top="this.$t('RM_C', intLoc)" title=""
                    v-if="compareBox.userName || compareBox.outingName">
                <b-button one-line class="m-1" v-on:click="rmFromCompare()">
                    <font-awesome-icon icon="minus" size="lg"/>
                </b-button>
            </a>
        </b-container>
    </div>
</template>

<script>
import { BContainer, BButton, BSpinner, BRow, BCol, BLink } from 'bootstrap-vue';
import {SubjTypes} from '@/plugins/SubjTypes.js';
import {WayTypes} from '@/plugins/WayTypes.js';

export default {
  name: 'Outing',
  components: {
    BContainer, BButton, BSpinner, BRow, BCol, BLink
  },
  data: function() {
    return {
      act: '/getOuting',
      showAll: false,
      outing: {},
      cmnts: [{}],
      userName: '',
      curUserName: '',
      outingName: '',
      outingWayType: '',
      outingSubjType: '',
      individ: '',
      unaided: '',
      intLoc: this.$i18n.locale,
      resLoc: '',
      desc: '',
      showCmnts: false,
      audio: '',
      showPlayer: false,
      //redir: false,
      metaDesc: null,
      showHand: false,
      loading: false,
      company: {},
      compareBox: {},
      //title: null
      //robots: 'index,follow'
    }
  },
  metaInfo() {
/*
    if( location.pathname.includes('%2C') ||
        location.pathname.includes('%3A') ||
        location.pathname.includes('%27') ||
        location.pathname.includes('%28') ||
        location.pathname.includes('%29') )
        return {title: this.outingName}
    else
*/
        return {
            title: this.getTitle(),
            meta: [
                { vmid: 'description', name: 'description', content: this.outing.metaDesc },
                //{ name: 'robots', content: this.robots }
            ],
            link: [
                { rel: 'canonical', href: 'https://www.libentour.com'+this.$repl20(location.pathname) }
            ]
        }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    let userNameIni = this.$route.params.userName;
    let outingNameIni = this.$route.params.itemName;
    this.compareBox = this.$store.state.compareBox;
    //alert(this.compareBox.outingName);
    //alert('2 '+this.$repl20(location.pathname));
    //if(this.$isCrowler()) window.location = '/Outing/'+outingNameIni+'/'+userNameIni;
    if(this.$isCrowler()) window.location = this.$repl20(location.pathname);
    else {
        this.userName = this.$rmEncHyp(userNameIni);
        this.outingName = this.$rmEncHyp(outingNameIni);
        this.getOuting();
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getTitle() {
        return this.outing.title;
    },
    handleScroll () {
        if(document.getElementById('Outing')!=null) {
            this.showHand =  window.scrollY > window.innerHeight;
        }
    },
/*
    href () { return 'https://www.libentour.com/Outing/'
            +this.$repl20(this.$encodeRFC(this.$addEncHyp(this.outingName)))
            +'/'
            + this.$repl20(this.$encodeRFC(this.$addEncHyp(this.userName)));
    },
    href () {
          //alert(this.$addEncHyp(this.outingName));
          return 'https://www.libentour.com/Outing/'
            +this.$addEncHyp(this.outingName)
            +'/'
            + this.$addEncHyp(this.userName);
    },
*/
    async getOuting() {
        this.loading = true;
        try {
            //alert('* * *'+this.userName+" "+this.outingName+" "+this.intLoc);
            const response = await this.$http.get(this.act, {
                params: {
                    outingName: this.outingName,
                    userName: this.userName,
                    redir: this.redir,
                    intLoc: this.$store.state.intLoc
                }
            });
            this.render(response.data);
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('Outing: getOuting() '+error.message);
            else if(error.response.status == 301) this.render(error.response.data);
            else {
                this.$showErr(error.response.data, error.response.status);
                this.$router.push('/');
            }
        }
        finally {
            this.loading = false;
        }
    },
    render(outing) {
        this.resLoc = outing.intLoc;
        this.outing = outing;
        //if(this.outing.duratD=='0' || this.outing.duratD=='1') this.pageTitle = this.$t('OUTING',this.resLoc) + ':' + this.outing.outingName;
        //else this.pageTitle = this.$t('OUTING_T',this.resLoc) + ':' + this.outing.outingName;
        this.desc = this.outing.outingDesc;
        if(outing.virtual) this.outingWayType = this.$t('OU_VRT',this.resLoc);
        else {
            for(let i = 0; i < WayTypes.length; i++) {
                this.outingWayType = this.outingWayType + this.cmpProperty(WayTypes[i]);
            }
            if(this.outingWayType.endsWith(', ')) this.outingWayType = this.outingWayType.substring(0,this.outingWayType.length-2);
        }
        for(let i = 0; i < SubjTypes.length; i++) this.outingSubjType = this.outingSubjType + this.cmpProperty(SubjTypes[i]);
        if(this.outingSubjType.endsWith(', ')) this.outingSubjType = this.outingSubjType.substring(0,this.outingSubjType.length-2);
        this.individ = outing.individ ? this.$t('C_INDIVID',this.resLoc): "";
        this.unaided = outing.unaided ? this.$t('C_UNAID',this.resLoc): "";
        this.cmnts = this.outing.cmnts;
        if(this.cmnts.length>0) this.showCmnts = true;
        if(typeof this.outing.audio!='undefined' && this.outing.audio!="") {
            this.showPlayer =  true;
            if(this.outing.audio.endsWith('>'))
                this.$refs.audio.src = this.outing.audio.slice(0, this.outing.audio.length-12);
            else this.$refs.audio.src = this.outing.audio;
        } else this.showPlayer =  false;
    },
    showOutingMarkers() {
        if(!this.outing.hasPlaces) return;
        this.$router.push({
            path: '/Map/OutingMarkers/'+this.$addEncHyp(this.outingName)+'/'+this.$addEncHyp(this.userName)
        })
    },
    showOutingPlacesList() {
        this.$router.push({
            path: '/OutingPlacesList'+'/'+this.$addEncHyp(this.outingName)+'/'+this.$addEncHyp(this.userName)
        })
    },
    cmpProperty(sType) {
        if(this.outing[sType[0]]) return this.$t(sType[1],this.resLoc)+', ';
        else return "";
    },



/*
    async goToCompany() {
        try {
            const response = await this.$http.get('/getCompany', {
                params: {
                    companyName: this.outing.companyName,
                    intLoc: this.intLoc
                }
            });
            this.company = response.data;
            window.open(this.company.homeUrl, '_blank');
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('Outing: goToCompany() '+error.message);
            else {
                this.$showErr(error.response.data, error.response.status);
                this.$router.push('/');
            }
        }
    },
*/
    comment() {
        if(!this.curUserName) this.$showMsg(this.$t("REG_FOR_CMNT"), 'info');
        else{
            this.$router.push({
                path: '/ManageCmnt',
                query: {
                    userNameForCmnt: this.$addEncHyp(this.outing.userName),
                    itemNameForCmnt: this.$addEncHyp(this.outing.outingName),
                    cmntName: '',
                    itemType: 'to'
                }
            })
        }
    },
    showOutingDetails() {
        if(this.outing.hasTrip) {
            this.$router.push({
               path: '/Tour/'+this.$addEncHyp(this.outingName)+'/'+this.$addEncHyp(this.userName),
            })
        }
        else if(this.outing.hasPlace) {
            this.$router.push({
               path: '/Place/'+this.$addEncHyp(this.outingName)+'/'+this.$addEncHyp(this.userName),
            })
        }
    },
    addToCompare() {
        this.$store.commit('setCompareBox', { "userName" : this.userName, "outingName": this.outingName });
        this.compareBox = { "userName" : this.userName, "outingName": this.outingName };
    },
    rmFromCompare() {
        this.$store.commit('setCompareBox', { "userName" : '', "outingName": '' });
        this.compareBox = { "userName" : '', "outingName": '' };

    },
    compare() {
        //alert(this.compareBox.outingName+' '+this.outingName);
        this.$router.push({ path: '/Compare/'+

                this.$addEncHyp(this.compareBox.userName) +'/'+
                this.$addEncHyp(this.compareBox.outingName) +'/'+
                this.$addEncHyp(this.userName) +'/'+
                this.$addEncHyp(this.outingName)

        })
    }
  },
  computed: {
  }

}

</script>

<style scoped>
#outingId {
    background-color: #0b6478;
}
h1{
    font-size: 1.8rem;
}
/*
h4{
    color: blue;
}
*/
</style>
